// extracted by mini-css-extract-plugin
module.exports = {"lightMode":"_db9b3e6"};